import React from "react";

function WhatIsMMS() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is Market Making Service?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A crypto market making service is a service provided by
                  specialized firms or platforms that helps maintain liquidity
                  and stabilize prices in cryptocurrency markets. Market makers
                  play a crucial role in trading by continuously offering to buy
                  and sell assets at specified prices (called bid and ask
                  prices) to ensure there is sufficient liquidity in the market.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WhatIsMMS;
